import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components/macro';

export const WIPPageStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media screen and (max-width: 768px) {
    overflow-y: auto;
  }
  @media screen and (max-width: 424px) {
    overflow-y: auto;
  }
`;

export const HeaderBoxStyled = muiStyled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 15,
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  padding: 0,
  margin: 0,
  [theme.breakpoints.down('md')]: {
    position: 'relative',
  },
}));

export const CardsRowSectionStyled = styled.div<{ $expanded: boolean }>`
  overflow: visible;
  margin: ${({ $expanded }): string => ($expanded ? '12px 0 0' : '0')};
  padding: ${({ $expanded }): string => ($expanded ? '0 8px 8px' : '0')};
  background-color: ${({ theme }): string => theme.colors.backgroundDefault};
  transition: margin 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  @media screen and (max-width: 768px) {
    margin: ${({ $expanded }): string => ($expanded ? '4px 0 0' : '0')};
    padding: ${({ $expanded }): string => ($expanded ? '0 4px 4px' : '0')};
  }
  @media screen and (max-width: 424px) {
    margin: ${({ $expanded }): string => ($expanded ? '4px 0 0' : '0')};
    padding: ${({ $expanded }): string => ($expanded ? '0 4px 4px' : '0')};
  }
`;

export const CardsRowCollapsibleStyled = styled.div<{ $expanded: boolean }>`
  overflow: ${({ $expanded }): string => ($expanded ? 'visible' : 'hidden')};
  max-height: ${({ $expanded }): string => ($expanded ? 'none' : '0')};
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const CardsRowLayoutWrapperStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;
  padding: 6px 0;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    flex-wrap: wrap;
    gap: 4px;
  }
  @media screen and (max-width: 424px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const DealerCardWrapStyled = styled.div`
  flex: 0 0 auto;
  min-width: 460px;
  width: fit-content;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }
  @media screen and (max-width: 424px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const TableContentWrapStyled = styled.div`
  margin-top: 0;
  padding: 12px 4px 0;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }): string => theme.colors.backgroundDefault};

  @media screen and (max-width: 768px) {
    flex: 1 0 auto;
    min-height: auto;
    overflow: visible;
  }
`;
